import React from 'react';


export default function ImgPopup(props) {
  var appUrl = `${process.env.REACT_APP_API_HOST}`;
  const { dtlRealFileNm, handleClosePopup } = { ...props };
  
  function handleOnClick() {
    handleClosePopup();
  }

  return (
    <div className="popUp-wrapper">
            <div className="popUp-container">
                <section className="popUp-box">
                    <div className='popUp-box-layout'>
                        {props.title && <p className='popUp-title cnfmPopup'>{props.title}</p>}
                        <p className={props.textLeft ? 'popUp-text' : 'popUp-text cnfmPopup'}>
                        <img 
                          src={`${appUrl}ezp2/comm/bnr/getImages/bnr?fileNm=${dtlRealFileNm}`}
                          alt="광고상세" 
                          className="banner" 
                        />
                        </p>
                        <div className="btnBox">
                            <button type="button" className="btn btnTwo btnCnfm" onClick={handleOnClick}>확인</button>
                        </div>
                    </div>
                </section>
            </div>
        </div>



    // <div className="layer-popup">
    //   <div className="popup-img">
    //     <button
    //       className="popup-close"
    //       onClick={handleClosePopup}
    //       type="button"
    //     >
    //     </button>
    //     <div className="popup-title">광고</div>
    //     <div className="popup-contents">
    //     <img 
    //       src={`${appUrl}ezp2/comm/bnr/getImages/bnr?fileNm=${dtlRealFileNm}`}
    //       alt="광고상세" 
    //       className="banner" 
    //     />
    //     </div>
    //   </div>
    // </div>
  );
}
